import { useTranslation } from 'react-i18next';
import { ToggleButton } from 'common/components/Inputs/ToggleGroup/ToggleButton';
import { ToggleGroup } from 'common/components/Inputs/ToggleGroup/ToggleGroup';
import { Dispatch, SetStateAction } from 'react';
import { ObjectValues } from 'src/common/tsHelpers';
import { pxToRem } from 'src/common/utils/fonts';

export const PeriodType = {
  TwoDays: 0,
  SevenDays: 1,
} as const;
export type PeriodTypeValue = ObjectValues<typeof PeriodType>;

type PeriodTypeSwitchProps = {
  value: number;
  onChange: Dispatch<SetStateAction<PeriodTypeValue>>;
};

export const PeriodTypeSwitch = ({ value, onChange }: PeriodTypeSwitchProps) => {
  const { t } = useTranslation();

  return (
    <ToggleGroup
      value={value}
      onChange={(_event, value) => {
        if (value === null) {
          return;
        }

        onChange(value);
      }}
      data-testid="period-type-selector"
      aria-label="Select period type"
      sx={{
        height: pxToRem(30),
        marginBottom: 0,
        '& > button': { whiteSpace: 'nowrap' },
      }}
    >
      <ToggleButton value={PeriodType.SevenDays} data-testid={'select-period-type-data'}>
        {t('graphs.periodTypes.sevenDays')}
      </ToggleButton>
      <ToggleButton value={PeriodType.TwoDays} data-testid={'select-period-type-voice'}>
        {t('graphs.periodTypes.twoDays')}
      </ToggleButton>
    </ToggleGroup>
  );
};
